import { render, staticRenderFns } from "./PolipectomiaEndoscopicaIntestinoCrassoViewComponent.vue?vue&type=template&id=e36924d0"
import script from "./PolipectomiaEndoscopicaIntestinoCrassoViewComponent.vue?vue&type=script&lang=js"
export * from "./PolipectomiaEndoscopicaIntestinoCrassoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports